var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualitySurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5909 3.78223V10.6665C23.5909 11.5999 23.5909 12.0666 23.7725 12.4231C23.9323 12.7367 24.1873 12.9917 24.5009 13.1515C24.8574 13.3331 25.3241 13.3331 26.2576 13.3331H33.1418M13.5909 24.9997V29.9997M26.9242 21.6663V29.9997M20.2576 17.4997V29.9997M33.5909 16.6467V28.6663C33.5909 31.4666 33.5909 32.8667 33.0459 33.9363C32.5666 34.8771 31.8017 35.642 30.8608 36.1214C29.7913 36.6663 28.3911 36.6663 25.5909 36.6663H14.9242C12.124 36.6663 10.7238 36.6663 9.65427 36.1214C8.71346 35.642 7.94856 34.8771 7.46919 33.9363C6.92422 32.8667 6.92422 31.4666 6.92422 28.6663V11.333C6.92422 8.53275 6.92422 7.13261 7.46919 6.06306C7.94856 5.12224 8.71346 4.35734 9.65427 3.87798C10.7238 3.33301 12.124 3.33301 14.9242 3.33301H20.2772C21.5001 3.33301 22.1116 3.33301 22.687 3.47116C23.1972 3.59364 23.685 3.79566 24.1323 4.06981C24.6369 4.37902 25.0693 4.8114 25.934 5.67615L31.2477 10.9899C32.1125 11.8546 32.5449 12.287 32.8541 12.7916C33.1282 13.2389 33.3303 13.7267 33.4527 14.2368C33.5909 14.8123 33.5909 15.4238 33.5909 16.6467Z",
    stroke: "#278DEC",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualitySurvey);
export default __webpack_public_path__ + "static/media/qualitySurvey.878f7e8b1881efee2e5af4daa3c36145.svg";
export { ForwardRef as ReactComponent };